import { render, staticRenderFns } from "./singleTermMarkentry.vue?vue&type=template&id=4e4d8971&"
import script from "./singleTermMarkentry.vue?vue&type=script&lang=js&"
export * from "./singleTermMarkentry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports